import { ReactElement, ReactNode } from 'react';

export interface ToolbarProps {
  left?: ReactNode;
  right?: ReactNode;
}

export function Toolbar({ left, right }: Readonly<ToolbarProps>): ReactElement {
  return (
    <div className="border-b-divider flex flex-wrap justify-between gap-4 border-0 border-b border-solid px-4 py-3">
      {left && <div className="grow flex flex-wrap justify-start gap-4 lg:flex-nowrap xl:w-1/2">{left}</div>}
      {right && (
        <div className="ml-0 md:ml-auto flex w-full md:w-auto flex-wrap justify-between md:justify-end items-end gap-4 lg:flex-nowrap">
          {right}
        </div>
      )}
    </div>
  );
}
